<template lang="pug">
.form(v-bind:class="{ opened: isActive }")
  .form-header(@click="toggle()")
    p お問い合わせはこちら
  .form-body
    div(v-if="status === 'form'")
      div(v-if="errors.length")
        ul.errors
          li(v-for="error in errors") {{ error }}
      div(v-else)
        p.heading
          | ささやかなご質問から、
          br
          | お気軽にお送りください。
      label お名前
      input.input(type="text", v-model="name", placeholder="お名前をご記入ください。")
      label メール
      input.input(
        type="email",
        v-model="email",
        placeholder="orient.sailing@example.com"
      )
      label 電話番号
      input.input(type="tel", v-model="tel", placeholder="080-0000-0000")
      label お問い合わせ内容
      textarea(v-model="message", placeholder="お問い合わせ内容をご記入ください。")
      .form-buttons
        button.button.button--submit(type="submit", @click="confirm()") 送信する
    div(v-else-if="status === 'confirm'")
      label お名前
      p.conform {{ name }}
      label メール
      p.conform {{ email }}
      label 電話番号
      p.conform {{ tel }}
      label お問い合わせ内容
      p.conform {{ message }}
      .form-buttons
        button.button.button--submit(
          type="submit",
          v-bind:class="{ disabled: isPush }",
          v-bind:disabled="isPush",
          @click="send()"
        ) 送信する
        button.button.button--return(
          type="submit",
          @click="updateStatus('form')"
        ) 戻る
    div(v-else-if="status === 'succeeded'")
      p.message お問い合わせを受け付けました。お問い合わせいただきました内容を確認後、担当者より改めてご連絡いたします。
      .form-buttons
        button.button.button--return(type="submit", @click="close()") 戻る
    div(v-else-if="status === 'failed'")
      p.message メッセージの送信に失敗しました。恐れ入りますが、時間をおいてもう一度お試しください。
      .form-buttons
        button.button.button--return(type="submit", @click="close()") 戻る
</template>

<script>
import { mapState, mapMutations } from "vuex";
import axios from "axios";
axios.defaults.headers.common = {
  "X-Requested-With": "XMLHttpRequest",
  "X-CSRF-TOKEN": document
    .querySelector('meta[name="csrf-token"]')
    .getAttribute("content"),
};

export default {
  computed: {
    ...mapState(["isActive"]),
  },
  data: function () {
    return {
      name: null,
      email: null,
      tel: null,
      message: null,
      status: "form",
      errors: [],
      isPush: false,
    };
  },
  methods: {
    ...mapMutations(["toggleForm"]),
    toggle() {
      this.toggleForm();
    },
    updateStatus: function (status) {
      this.status = status;
    },
    close: function () {
      this.name = null;
      this.email = null;
      this.tel = null;
      this.message = null;
      this.toggleForm();
      setTimeout(() => (this.status = "form"), 500);
    },
    confirm: function () {
      this.errors = [];
      if (!this.name) {
        this.errors.push("お名前をご記入ください。");
      }
      if (!this.email) {
        this.errors.push("メールアドレスをご記入ください。");
      }
      if (!this.tel) {
        this.errors.push("電話番号をご記入ください。");
      }
      if (!this.message) {
        this.errors.push("お問い合わせ内容をご記入ください。");
      }
      if (this.name && this.email && this.message) {
        this.updateStatus("confirm");
      }
    },
    send: function () {
      this.isPush = true;
      if (this.isPush) {
        axios
          .post(`/design-base/api/v1/indices/inquiry`, {
            inquiry: {
              name: this.name,
              email: this.email,
              tel: this.tel,
              message: this.message,
            },
            headers: {
              "content-type": "application/json",
            },
            timeout: 3000,
          })
          .then((response) => {
            this.status = "succeeded";
            this.isPush = false;
          })
          .catch((error) => {
            console.log(error);
            this.status = "failed";
            this.isPush = false;
          });
      }
    },
  },
};
</script>


<style lang="scss" scoped>
@import "../../../assets/stylesheets/variables";
.form {
  width: 300px;
  height: 470px;
  box-shadow: 0px 0px 5px 1px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  background: #fff;
  position: fixed;
  bottom: $space-xl;
  right: $space-m;
  z-index: 9999;
  visibility: hidden;
  opacity: 0;
  overflow: hidden;
  transition: 0.3s;
  @media only screen and( max-width: 768px) {
    width: calc(100% - 32px);
  }
  &-header {
    height: 40px;
    background-color: $bg-secondary;
    color: #fff;
    text-align: center;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    p {
      font-weight: bold;
    }
    &:after {
      font-family: "Ionicons";
      content: "\f2d7";
      position: absolute;
      right: 12px;
      top: 8px;
      font-size: 24px;
    }
  }
  &-body {
    height: 430px;
    padding: 16px;
    overflow-y: scroll;
    box-sizing: border-box;
    p {
      margin: 6px 0 12px;
    }
    .heading {
      margin: 0 0 6px;
      text-align: center;
      font-weight: bold;
      font-size: 12px;
      line-height: 1.5;
    }
    .message {
      padding: 16px 0;
      line-height: 1.5;
    }
    .errors {
      margin-left: 18px;
      margin-bottom: 6px;
      font-size: 12px;
      li {
        color: #d23f40;
        list-style: disc;
      }
    }
    .conform {
      padding: 6px;
      background: #f7f7f7;
    }
  }
  &-buttons {
    display: flex;
  }
  label {
    // margin-bottom: $space-s;
    color: #767676;
    font-size: 10px;
    font-weight: bold;
    span {
      color: #d23f40;
      font-size: 15px;
    }
  }
  .input {
    width: 100%;
    height: 35px;
    margin-top: 4px;
    margin-bottom: 8px;
    padding: 6px 12px;
    line-height: 1.5;
    border: solid 1px #e5e1e1;
    box-shadow: none;
    display: block;
    font-size: 12px;
    vertical-align: middle;
    background-color: #fff;
    background-image: none;
    border-radius: 4px;
    transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
    appearance: none;
    -webkit-appearance: none;
    &:focus {
      border-color: #333;
      outline: none;
    }
    &::placeholder {
      color: #8b8b8b;
    }
  }
  textarea {
    height: 100px;
    margin-top: 6px;
    padding: 10px 12px 6px;
    line-height: 1.5;
    border: solid 1px #e5e1e1;
    box-shadow: none;
    display: block;
    width: 100%;
    color: #8d8d8d;
    vertical-align: middle;
    background-color: #fff;
    background-image: none;
    font-size: 12px;
    border-radius: 4px;
    transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
    appearance: none;
    -webkit-appearance: none;
    &:focus {
      border-color: #333;
      outline: none;
    }
    &::placeholder {
      color: #8b8b8b;
    }
  }
  .button {
    width: 100%;
    margin-top: 12px;
    border-radius: 3px;
    font-size: 14px;
    font-weight: bold;
    padding: $space-s 0;
    &:first-child {
      margin-right: 3px;
    }
    &:nth-child(2) {
      margin-left: 3px;
    }
    &:focus {
      outline: none;
    }
    &--submit {
      background: #333;
      color: #fff;
      transition: 0.3s;
      &.disabled {
        opacity: 0.3;
        transition: 0.3s;
      }
    }
    &--return {
      background: #ccc;
      color: #fff;
    }
  }
}
.opened {
  bottom: $space-m;
  visibility: visible;
  opacity: 1;
  transition: 0.3s;
}
</style>
